import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Stack,
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  CircularProgress,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { getFirestore, collection, getDocs, query, orderBy } from 'firebase/firestore';

export default function EmployeesPage() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const db = getFirestore();
      const q = query(collection(db, 'employees'), orderBy('createdAt', 'desc'));
      const snap = await getDocs(q);
      setEmployees(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const countPermissions = (emp) => {
    if (emp.role === 'admin') return 'Admin (todos)';
    if (!emp.permissions) return '0 permisos';
    return `${Object.values(emp.permissions).filter(Boolean).length} permisos`;
  };

  return (
    <>
      <Helmet>
        <title>Empleados | BBTC</title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 5 }}>
          <Typography variant="h4">Empleados</Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/dashboard/employees/information')}
          >
            Nuevo empleado
          </Button>
        </Stack>

        <Card>
          {loading ? (
            <Stack alignItems="center" sx={{ p: 4 }}>
              <CircularProgress />
            </Stack>
          ) : (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Rol</TableCell>
                    <TableCell>Roles / Funciones</TableCell>
                    <TableCell>Permisos</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employees.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No hay empleados registrados.
                      </TableCell>
                    </TableRow>
                  ) : (
                    employees.map((emp) => (
                      <TableRow key={emp.id} hover>
                        <TableCell>{emp.name || '—'}</TableCell>
                        <TableCell>{emp.email}</TableCell>
                        <TableCell>
                          <Chip
                            label={emp.role === 'admin' ? 'Admin' : 'Empleado'}
                            color={emp.role === 'admin' ? 'primary' : 'default'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                            {(emp.roles || []).map((rl) => (
                              <Chip
                                key={rl}
                                label={rl}
                                size="small"
                                variant="outlined"
                                color={/instructor/i.test(rl) ? 'info' : 'default'}
                              />
                            ))}
                          </Stack>
                        </TableCell>
                        <TableCell>{countPermissions(emp)}</TableCell>
                        <TableCell>
                          <Chip
                            label={emp.active ? 'Activo' : 'Inactivo'}
                            color={emp.active ? 'success' : 'error'}
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            onClick={() => navigate(`/dashboard/employees/information?id=${emp.id}`)}
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </Container>
    </>
  );
}
